import Store from "App/Store.js";

export default reg => {
	Store.dispatch({
		type: "registration",
		org: {
			Id: reg.Org.Id,
			Name: reg.Org.Name,
			NameNatural: `${reg.Org.NameHasThe ? " the " : ""} ${reg.Org.Name}`,
			NameShort: reg.Org.NameShort,
			NameShortNatural: `${reg.Org.NameHasThe ? " the " : ""} ${reg.Org.NameShort}`,
			NameTrade: reg.Org.NameTrade,
			Details: reg.OrgDetails,
			Logo: reg.Org.LogoTrade || reg.Org.Logo,
			AddressLookupService: reg.Org.AddressLookupService,
			GiftAidEnabled: reg.GiftAidEnabled,
			MarketingConsents: reg.MarketingConsents,
			CookiesPolicyUrl: reg.CookiesPolicyUrl,
			PrivacyPolicyUrl: reg.PrivacyPolicyUrl,
			TermsAndConditionsUrl: reg.TermsAndConditionsUrl,
			PostagePolicySlug: reg.PostagePolicySlug,
			SavesDob: reg.Org.SavesDob,
			WebsiteUrl: reg.Org.WebsiteUrl,
			AutomaticDiscounts: reg.AutomaticDiscounts,
			NavigationLinks: reg.NavigationLinks,
			Banners: reg.Banners,
			GoogleTagManagerId: reg.GoogleTagManagerId
		},
		paymentMethods: (reg.PaymentMethods || []),
		strings: {
			index: reg.LandingText,
			checkout: reg.CheckoutText,
			checkoutSeatReservation: reg.CheckoutTextSeatReservation
		},
		theme: {
			AccentColour: reg.AccentColour,
			AccentColourSecondary: reg.AccentColourSecondary,
			CSSVariables: true,
			FontFamily: reg.FontFamily,
			FontFamilyGoogle: reg.FontFamilyGoogle
		}
	});
};
